import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Agency = {
  id: string;
  user_id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  email: string | null;
  subscription_plan: 'starter' | 'growth' | 'pro' | null;
  subscription_status: 'active' | 'trialing' | 'canceled' | 'past_due' | 'suspended' | null;
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  billing_interval: 'monthly' | 'yearly' | null;
  trial_ends_at: string | null;
  canceled_at: string | null;
  subscription_ends_at: string | null;
  created_at: string;
  updated_at: string;
};

export type ScreeningQuestion = {
  id: string;
  agency_id: string;
  label: string;
  type: 'short_text' | 'long_text' | 'yes_no' | 'multiple_choice';
  options: string[];
  required: boolean;
  position: number;
  created_at: string;
};

export type Application = {
  id: string;
  agency_id: string;
  candidate_name: string;
  candidate_email: string;
  candidate_phone: string | null;
  cv_url: string | null;
  status: 'new' | 'reviewing' | 'interview' | 'hired' | 'rejected';
  submitted_at: string;
};

export type ApplicationAnswer = {
  id: string;
  application_id: string;
  question_id: string | null;
  question_label: string;
  answer: string | null;
  created_at: string;
};

export type Message = {
  id: string;
  application_id: string;
  agency_id: string;
  sender: 'agency' | 'candidate';
  body: string;
  read: boolean;
  created_at: string;
};

export type AuditLog = {
  id: string;
  agency_id: string | null;
  action: string;
  details: Record<string, unknown>;
  ip_address: string | null;
  created_at: string;
};
